/** Editor für das Aussehen der Figur, mit Vorschau. */
import type { Appearance, HairStyle } from '../../lib/appearance';
import { HAIR_COLORS, HAIR_STYLES, PANT_COLORS, SHIRT_COLORS, SKIN_TONES } from '../../lib/appearance';
import { PlayerFigure } from './PlayerFigure';

function Swatches({ label, colors, value, onChange }: { label: string; colors: string[]; value: string; onChange: (c: string) => void }) {
  return (
    <div>
      <div className="mb-1 text-xs text-panel-500 dark:text-panel-400">{label}</div>
      <div className="flex flex-wrap gap-2">
        {colors.map((c) => (
          <button
            key={c}
            type="button"
            aria-label={`${label} ${c}`}
            aria-pressed={value === c}
            onClick={() => onChange(c)}
            className={`h-7 w-7 rounded-full border-2 ${value === c ? 'border-accent-500' : 'border-transparent'}`}
            style={{ backgroundColor: c }}
          />
        ))}
      </div>
    </div>
  );
}

export function AppearanceEditor({ value, onChange }: { value: Appearance; onChange: (next: Appearance) => void }) {
  const set = <K extends keyof Appearance>(key: K, v: Appearance[K]) => onChange({ ...value, [key]: v });
  return (
    <div className="grid gap-4 sm:grid-cols-[160px_1fr]">
      <div className="flex items-center justify-center rounded-lg bg-panel-100 p-3 dark:bg-panel-800">
        <svg viewBox="-30 -80 60 90" className="h-40 w-auto" role="img" aria-label="Vorschau der Figur">
          <PlayerFigure a={value} />
        </svg>
      </div>
      <div className="space-y-3">
        <div>
          <div className="mb-1 text-xs text-panel-500 dark:text-panel-400">Frisur</div>
          <div className="flex gap-2">
            {HAIR_STYLES.map((h) => (
              <button
                key={h.value}
                type="button"
                onClick={() => set('hair', h.value as HairStyle)}
                className={`rounded-md border px-3 py-1 text-sm ${value.hair === h.value ? 'border-accent-500 font-medium' : 'border-panel-300 dark:border-panel-700'}`}
              >
                {h.label}
              </button>
            ))}
          </div>
        </div>
        <Swatches label="Hautton" colors={SKIN_TONES} value={value.skin} onChange={(c) => set('skin', c)} />
        <Swatches label="Haarfarbe" colors={HAIR_COLORS} value={value.hairColor} onChange={(c) => set('hairColor', c)} />
        <Swatches label="Oberteil" colors={SHIRT_COLORS} value={value.shirt} onChange={(c) => set('shirt', c)} />
        <Swatches label="Hose" colors={PANT_COLORS} value={value.pants} onChange={(c) => set('pants', c)} />
      </div>
    </div>
  );
}
